import React from 'react'
import { inject, observer } from 'mobx-react'
import classnames from 'classnames'
import DynamicGeoJSON from 'components/map/DynamicGeoJSON'

const UserShapefileLayerShape = ({
  uiStore,
  shape,
  userShapefileList
}) => (
  <DynamicGeoJSON
    startInBack
    key={`${shape.id}-${userShapefileList.selectedShape === shape}`}
    data={shape.geoJSON}
    smoothFactor={shape.smoothFactor}
    className={classnames({
      focused: true,
      'leaflet-interactive': true,
      'region-buffer': true,
      selected: shape.selected
    })}
    onClick={() => {
      shape.toggleSelected()
      if (
        userShapefileList.selectedLevel.preview === false ||
        uiStore.zoomWhilePreviewing === true
      ) {
        uiStore.setBoundsToItem(shape)
      }
    }}
    fillOpacity='1'
  />
)

export default inject('uiStore')(
  observer(UserShapefileLayerShape)
)
